"use client"

import { reatomContext } from "@reatom/react"
import type { ReactNode } from "react"
// import { rootFrame } from "./setup"

export function ReatomProvider({ children }: { children: ReactNode }) {
  return (
    <reatomContext.Provider value={null}>{children}</reatomContext.Provider>
  )
}
